import { render, staticRenderFns } from "./Ops.vue?vue&type=template&id=481cf43a&"
import script from "./Ops.vue?vue&type=script&lang=js&"
export * from "./Ops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports